// apps/web/src/features/admin/form-config/recognition/CorrectionsStream.tsx

interface CorrectionEvent {
  timestamp: string;
  documentId: string;
  wrongFormId: string;
  correctFormId: string;
}

interface CorrectionsStreamProps {
  events: CorrectionEvent[];
}

export function CorrectionsStream({ events }: CorrectionsStreamProps) {
  if (events.length === 0) return null;

  return (
    <div className="corrections-stream">
      <h4>RECENT CORRECTIONS</h4>
      <ul>
        {events.map((evt, i) => (
          <li key={i} className="corrections-stream__item">
            <span className="corrections-stream__time">
              {new Date(evt.timestamp).toLocaleString()}
            </span>
            <span className="corrections-stream__doc">{evt.documentId}</span>
            <span className="corrections-stream__change">
              {evt.wrongFormId} &rarr; {evt.correctFormId}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
